import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters';
import user from './modules/user.js';// 用户登录相关

Vue.use(Vuex);

export default new Vuex.Store({
    modules: { user },
    state: {},
    getters,
})
